import { HttpClient } from '@angular/common/http';
import { HttpListResponse, ILocation, RelatedLocation } from '@ess-front/shared';
import { Observable } from 'rxjs';
import { BEExperience } from '@shared/models/be-experience.model';
import { environment } from '@environment';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ExperienceElementsService {
  constructor(private httpClient: HttpClient) {}

  public getPlace$(slug: string, language: string): Observable<BEExperience> {
    const url = `${environment.apiEnv}api/places/${slug}/?lan=${language}`;
    return this.httpClient.get<BEExperience>(url);
  }

  public getHotel$(slug: string, language: string): Observable<BEExperience> {
    const url = `${environment.apiEnv}api/hotels/${slug}/?lan=${language}`;
    return this.httpClient.get<BEExperience>(url);
  }

  public getExperienceBySlug$(slug: string, language: string): Observable<BEExperience> {
    const url = `${environment.apiEnv}api/experience_modules/${slug}/?lan=${language}`;
    return this.httpClient.get<BEExperience>(url);
  }

  public getBookingExperienceByHash$(bookingHash: string, id: number): Observable<BEExperience> {
    const url = `${environment.apiEnv}api/booking/${bookingHash}/experiences/${id}/`;
    return this.httpClient.get<BEExperience>(url);
  }

  public getRelated$(id: number, language: string): Observable<ILocation[]> {
    const url = `${environment.apiEnv}api/experience_modules/${id}/related/?lan=${language}`;

    return this.httpClient.get<HttpListResponse<RelatedLocation>>(url).pipe(
      map(response =>
        response.results.reduce((acc: ILocation[], current: RelatedLocation) => {
          return [...acc, ...current.related_objects];
        }, []),
      ),
    );
  }
}
